module.exports = __webpack_public_path__ + "assets/img/dzh-6.33c0b0e1.jpg";